import { beginRouteNavigation, getPreviousRoute, rememberRoute } from '~/utils/route-scroll'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  if (!getPreviousRoute()) rememberRoute(router.currentRoute.value)
  router.beforeEach((_to, from) => {
    beginRouteNavigation()
    rememberRoute(from)
  })
})
